<template>
  <div v-if="methods.length > 0" class="ds-method-docs">
    <template v-for="method in methods" :key="method.name">
      <div>
        <h5>{{ method.name }}</h5>
        <div v-if="method.desc">{{ method.desc }}</div>
        <div v-if="method.returns">Returns: {{ method.returns.type }}</div>
        <h6>Parameters</h6>
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(parameter, idx) in method.params"
              :key="'tr_' + idx"
            >
              <tr>
                <td>{{ parameter.name }}</td>
                <td>{{ parameter.type }}</td>
                <td>
                  <div v-html="parameter.desc"></div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { GlueDocs, MethodDoc } from "./glue-documentation-types";

@Component({ name: "method-docs" })
export default class GlueDocDisplayOptions extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get methods(): MethodDoc[] {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (doc.methods) {
        return doc.methods;
      }
    }
    return [];
  }
}
</script>
